
import { defineComponent } from 'vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import EstateAgentReviewStars from '@/estate-agent-review/components/EstateAgentReviewStars.vue';

export default defineComponent({
  components: {
    ResizableImage,
    EstateAgentReviewStars,
  },
  props: {
    estateAgent: Object,
  },
});
